import React from 'react';

import GrupoIncentivoDetails from 'components/Tvendo/Sale/QuotaBPartner/CuotasIncentivos/Unilever/GrupoIncentivo/GrupoIncentivoDetails/List.js';

export default function () {
  return <GrupoIncentivoDetails />;
}
